/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Body from "ui/kit/typography/Body";
import Button from "ui/kit/buttons/Button";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {Export_Piece$data} from "ui/feature/piece-play/export/__generated__/Export_Piece.graphql";

interface Props {
    piece: Export_Piece$data
}

const Export: React.FC<Props> = ({piece}) => {

    const midiFileDownloadUrl = React.useMemo(() => {
        const file = piece.file;
        if (!file) {
            return null;
        }
        return file.midi_file_download_url;
    }, [piece]);

    const audioFileDownloadUrl = React.useMemo(() => {
        const file = piece.file;
        if (!file) {
            return null;
        }
        return file.audio_file_download_url;
    }, [piece]);

    const executeDownloadMIDI = React.useCallback(() => {
        if (midiFileDownloadUrl) {
            window.location.assign(midiFileDownloadUrl);
        }
    }, [midiFileDownloadUrl]);

    const executeDownloadAudio = React.useCallback(() => {
        if (audioFileDownloadUrl) {
            window.location.assign(audioFileDownloadUrl)
        }
    }, [audioFileDownloadUrl])

    return (
        <Body>
            {midiFileDownloadUrl ? <Button title={"Download MIDI"} onClick={executeDownloadMIDI}/> :
                <Body>MIDI file not generated yet. Please try again later.</Body>}
            {audioFileDownloadUrl ? <Button title={"Download Audio"} onClick={executeDownloadAudio}/> :
                <Body>Audio file not generated yet</Body>}
        </Body>
    )
}

export default createFragmentContainer(Export, {
    piece: graphql`
    fragment Export_Piece on MusicPiece {
        id
        file {
            version
            midi_file_download_url
            audio_file_download_url
        }
    }
    `
});